export default {
  primary: {
    backgroundColor: '#efefef',
  },
  secondary: {
    backgroundColor: '#fff',
  },
};
